var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.381,
    height: 32.381,
    rx: 16.1905,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2738 11.6081C13.2738 10.4377 13.2738 9.8525 13.5547 9.43212C13.6763 9.25014 13.8325 9.09389 14.0145 8.97229C14.4349 8.69141 15.0201 8.69141 16.1905 8.69141C17.3609 8.69141 17.9461 8.69141 18.3664 8.97229C18.5484 9.09389 18.7046 9.25014 18.8262 9.43212C19.1071 9.8525 19.1071 10.4377 19.1071 11.6081",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5237 17.8574V17.4408C24.5237 14.6909 24.5237 13.316 23.6695 12.4617C22.8151 11.6074 21.4402 11.6074 18.6904 11.6074H13.6904C10.9405 11.6074 9.5656 11.6074 8.71133 12.4617C7.85706 13.316 7.85706 14.6909 7.85706 17.4408V17.8574C7.85706 20.6073 7.85706 21.9822 8.71133 22.8365C9.5656 23.6908 10.9405 23.6908 13.6904 23.6908H18.6904C21.4402 23.6908 22.8151 23.6908 23.6695 22.8365C24.5237 21.9822 24.5237 20.6073 24.5237 17.8574Z",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85706 15.3574C7.85706 15.3574 10.05 18.6908 16.1904 18.6908C22.3307 18.6908 24.5237 15.3574 24.5237 15.3574",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2946 15.9837H16.1904M16.3987 15.9837C16.3987 16.0988 16.3055 16.1921 16.1904 16.1921C16.0753 16.1921 15.9821 16.0988 15.9821 15.9837C15.9821 15.8686 16.0753 15.7754 16.1904 15.7754C16.3055 15.7754 16.3987 15.8686 16.3987 15.9837Z",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate2);
export default __webpack_public_path__ + "static/media/create-2.95bba06fe978375e6958ac83ef609a90.svg";
export { ForwardRef as ReactComponent };